import type { FC } from 'react';
import React from 'react';

import { validatorMap } from './helpers';
import type { TInvestAddressRegistrationField } from './models';

export const InvestAddressRegistrationField: FC<TInvestAddressRegistrationField> = ({
    AddressRegistrationInput,
    Field,
    className,
    isRequired = false,
    name = 'address-registration',
    settings = {},
    disabled = false,
    validateType = 'address',
    onSelect,
}) => {
    return (
        <div className={className}>
            <Field<string>
                data={settings}
                // Если есть несколько полей и происходил onSelect, то перекидывает на следующее даже если был не валидный ввод
                // dispatchesFocus
                isRequired={isRequired}
                name={name}
                receivesFocus
                render={({ input, meta }) => (
                    <AddressRegistrationInput
                        disabled={disabled}
                        input={input}
                        meta={meta}
                        name={name}
                        onSelect={onSelect}
                        settings={settings}
                    />
                )}
                validate={validatorMap[validateType](name)}
            />
        </div>
    );
};
